import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

interface Props {
  email: string
  date: string
}

export function UnsubscribeDataEmail(props: Props) {
  const { date, email } = props
  const texts = useTexts()

  return (
    <Alert severity="info">
      <AlertTitle>{texts.unsubscribeEmailTitle}</AlertTitle>
      {texts.unsubscribeEmailDescription(email, date)}
    </Alert>
  )
}
